import React from "react";
import { graphql } from "gatsby";
import { last } from "lodash";

import Article from "../ui/article/Article";
import Layout from "../components/Layout";

const transformData = (data) => {
  const {
    doi,
    history,
    submissionTypes,
    id,
    pmcId,
    pmId,
    proteopedia,
    reviewPanel,
    species,
    corrections,
    versions,
  } = data;

  const reviewers = versions.map((v) =>
    v.reviews.map((r) => {
      if (r.status.submitted) {
        return r.openAcknowledgement ? r.reviewer.displayName : "Anonymous";
      }
      return null;
    })
  );

  const version = versions
    .filter((v) => v.decision === "publish")
    .map((v) => ({
      title: v.title,
      authors: v.authors,
      abstract: v.abstract,
      image: v.image,
      imageTitle: v.imageTitle,
      imageCaption: v.imageCaption,
      patternDescription: v.patternDescription,
      methods: v.methods,
      reagents: v.reagents,
      references: v.references,
      acknowledgements: v.acknowledgements,
      funding: v.funding,
      extendedData: v.extendedData,
    }))
    .pop();

  const article = {
    doi,
    history,
    submissionTypes,
    id,
    pmcId,
    pmId,
    proteopedia,
    species,
    corrections,
    reviewers,
    reviewPanel,
    version,
  };

  return article;
};

const ArticlePage = ({ data }) => {
  const article = (
    <Article article={transformData(data.micropubApp.manuscript)} />
  );

  const { title } = last(data.micropubApp.manuscript.versions);
  return (
    <Layout
      children={article}
      title={`${title.replace(/(<([^>]+)>)/gi, "")} | microPublication`}
    />
  );
};

export const query = graphql`
  query($id: ID!) {
    micropubApp {
      manuscript(id: $id) {
        id
        submissionTypes
        doi
        pmcId
        pmId
        proteopedia
        reviewPanel
        species
        corrections {
          doi
          description
          correctionType
          date
        }
        history {
          received
          revisionReceived
          accepted
          published
          indexed
        }
        versions {
          id
          decision
          abstract
          acknowledgements
          authors {
            affiliations
            credit
            email
            firstName
            lastName
            submittingAuthor
            correspondingAuthor
            equalContribution
            WBId
            orcid
          }
          extendedData {
            description
            doi
            resourceType
            name
            url
          }
          funding
          image {
            url
          }
          imageCaption
          imageTitle
          methods
          reagents
          patternDescription
          references {
            reference
            pubmedId
            doi
          }
          title
          reviews {
            reviewer {
              displayName
            }
            openAcknowledgement
            status {
              submitted
            }
          }
        }
      }
    }
  }
`;

export default ArticlePage;
